import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { catchError, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

import {
  AvlaGenericComponent,
  I18nService,
  LoadInfoDTO,
  MessageService,
} from 'shared-angular-components-avla';
import { CountryService } from 'shared-angular-components-avla/country/country.service';
import {
  AuthService,
  AvlaRestClientService,
  NotificationMessageDto,
  OptionElementDTO,
  RetryNotificationMessageService,
} from 'base-angular-avla';
import {
  BRAZIL,
  CHILE,
  MEXICO,
  PERU,
  UNITED_STATES
} from 'shared-angular-components-avla/country/country.constants';
import { CountryModel } from 'shared-angular-components-avla/country/country.model';

import { CountrySelectionComponent } from './components/country-selection/country-selection.component';
import { CountriesService } from './countries.service';

declare let $: any;
declare let window: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [RetryNotificationMessageService],
})
export class AppComponent extends AvlaGenericComponent implements OnInit {
  static DEFAUL_AVLA_TEST_CONNECTION_URL =
    'https://avla-connection-test-1.s3.amazonaws.com/hola_mundo.txt';

  static AVLA_TEST_CONNECTION_URLS = '/assets/avlaTestConnectionUrls.json';

  constructor(
    protected avlaRestClient: AvlaRestClientService,
    private viewContainerRef: ViewContainerRef,
    protected messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    protected authService: AuthService,
    private route: ActivatedRoute,
    protected i18n: I18nService,
    private titleService: Title,
    protected router: Router,
    public countriesService: CountriesService,
    protected countryService: CountryService,
    protected retryNotificationMessageService: RetryNotificationMessageService,
    private http: HttpClient
  ) {
    super(avlaRestClient, messageService, router, authService, i18n);
    //Configura el login para solicitar el organizationUnitName o no
    this.authService.askOrganizationUnitName = false;
    this.window = window;
  }

  @ViewChild('oldCountrySelector')
  oldCountrySelector: CountrySelectionComponent;

  public ngOnInit() {
    this.lastCompletedNavigationWasHome = this.isHomeRoute(this.router.url);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log(event.url);
        const isPath =
          event.url.includes('/home') || event.url.includes('/viewClient')
            ? true
            : false;
        console.log(isPath);
        if (isPath) {
          (document.querySelector('body') as HTMLElement).style.overflowY =
            'hidden';
        } else {
          (document.querySelector('body') as HTMLElement).style.overflowY =
            'scroll';
        }
      }
    });

    this.redirectUrl = this.splitUrlRequestedToRedirect(
      this.window.location.href
    );
    const staticCountries = [BRAZIL, CHILE, MEXICO, PERU, UNITED_STATES];
    let cdCountryFromQueryString: string = null;
    if (this.redirectUrl.includes('cdCountry')) {
      cdCountryFromQueryString = this.getCountryFromQueryString(
        this.redirectUrl
      );
    }
    if (cdCountryFromQueryString && cdCountryFromQueryString != '') {
      const staticCountry = staticCountries.find(
        x => x.isoCode.toLowerCase() == cdCountryFromQueryString.toLowerCase()
      );
      if (staticCountry) {
        this.countryService
          .initCountryByISOCode(staticCountry.isoCode)
          .then((country: CountryModel) => {
            this.countryService.setSelectedCountry(country);
          });
      }
    }
    this.countryService.countryChanged.subscribe(e => {
      this.countriesService.countryCodeGlobal = e;
      if (this.oldCountrySelector) {
        this.oldCountrySelector.selectCountry(e);
      }
      this.loadingPage.setLoading();
      setTimeout(() => this.loadingPage.setLoaded(), 0);
    });
    this.avlaRestClient.countDownChanged.subscribe(countDown => {
      this.retryNotificationMessageService.announcedMessage(
        new NotificationMessageDto(
          'warning',
          this.i18n.getTranslation(
            'BAA_AVLA_REST_CLIENT_SERVICE_RETRYING_NOTIFICATION',
            [countDown]
          ),
          1000
        )
      );
    });
    // (<any>(this.window)).loading_screen.finish();
    this.i18n.subscribe(
      traducciones => {
        this.translationLoaded = true;
        console.log('Se cargaron las traducciones.');
      },
      error => {
        console.log('No pudieron cargarse las traducciones.');
      }
    );
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        setTimeout(() => {
          this.loadingPage.setLoading();
        }, 0);
        console.log('NavigationStart');
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        if (event instanceof NavigationEnd) {
          const navigationEndedAtHome = this.isHomeRoute(
            event.urlAfterRedirects
          );
          if (
            navigationEndedAtHome !== this.lastCompletedNavigationWasHome
          ) {
            this.recreateRouterOutlet();
          }
          this.lastCompletedNavigationWasHome = navigationEndedAtHome;
        }
        setTimeout(() => {
          this.loadingPage.setLoaded();
        }, 0);
        console.log(event.constructor.name);
      }
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      })
      .pipe(filter(route => route.outlet === 'primary'))
      .mergeMap(route => route.data)
      .subscribe(event => {
        if (event['pageTitle']) {
          this.titleService.setTitle('RIESGOS - ' + event['pageTitle']);
        }
      });

    this.authService.messageAnnouncedOptionsLoaded$.subscribe(() => {
      this.optionsLoaded = true;
    });

    this.setAlwaysAllowedUrls();
    this.authService.messageAnnouncedUserInfoDone$.subscribe(() => {
      if (this.window.DD_RUM && this.authService.userInfoDto) {
        console.log('Seteando user en DD_RUM');
        this.window.DD_RUM.setUser({
          id: this.authService.userInfoDto.id,
          name: this.authService.userInfoDto.username,
        });
      }
    });
    this.authService.messageAnnouncedRedirectAfterLogin$.subscribe(() => {
      if (!this.authService.redirectUrl) {
        this.authService.redirectUrl = this.defaultRedirectUrl;
      } else {
        if (
          this.redirectUrl &&
          this.redirectUrl != this.authService.defaultRedirectUrl &&
          this.redirectUrl != this.authService.redirectUrl &&
          this.redirectUrl != AppComponent.URL_LOGIN
        ) {
          this.isValidSession = true;
          const redirectUrl: string = this.deleteQueryStringToUrl(
            this.redirectUrl
          );
          const queryParams = this.generateQueryParams(this.redirectUrl);
          this.redirectUrl = null;
          return this.router.navigate([redirectUrl], { queryParams });
        } else {
          this.isValidSession = true;
          const redirectUrl = this.authService.redirectUrl;
          this.authService.redirectUrl = this.defaultRedirectUrl;
          return this.router.navigate([redirectUrl]);
        }
      }
      this.isValidSession = true;
      const redirectUrl = this.authService.redirectUrl;
      this.authService.redirectUrl = null;
      // this.router.navigate([this.authService.defaultRedirectUrl]);
      this.router.navigate([redirectUrl]);
    });
    this.authService.messageAnnouncedLogoutSignal$.subscribe(() => {
      console.log('Se recibe evento de logout, redireccionando a login.');
      if (this.window.DD_RUM) {
        console.log('Limpiando user en DD_RUM');
        this.window.DD_RUM.clearUser();
      }
      this.optionsLoaded = true;
      this.isValidSession = false;
      this.loadingPage.setLoadedError();
      this.router.navigate([AppComponent.URL_LOGIN]);
    });
    this.authService.messageAnnouncedRedirectAccessForbidden$.subscribe(
      (code: number) => {
        if (this.avlaRestClient.tokenExist) {
          this.router.navigate(['/errors/access-forbidden/' + code.toString()]);
        } else {
          this.router.navigate([
            '/errorsLogout/access-forbidden/' + code.toString(),
          ]);
        }
      }
    );
    if (!this.authService.redirectUrl) {
      this.authService.redirectUrl = this.defaultRedirectUrl;
    }
    this.rememberMe =
      this.authService.rememberMe === null
        ? AuthService.DEFAULT_REMEMBER_ME
        : this.authService.rememberMe;
    if (this.avlaRestClient.tokenExist && this.rememberMe) {
      // Este if permite entrar igualmente al login a pesar que exista sesión previa, se desloguea primero
      if (this.authService.redirectUrl == AppComponent.URL_LOGIN) {
        this.authService.logout().subscribe(
          data => {
            this.authService.emmitSignalLogout();
          },
          err => {
            this.routeAccordingError(err);
          }
        );
      } else {
        setTimeout(() => {
          console.log('setTimeout en app.component');
          this.authService.emmitLoginStatus(true);
        }, 10);
        this.loadUserInfo(); // Hay otro subscribe dentro
        this.loadOptions(this.authService.redirectUrl, () => {
          this.optionsLoaded = true;
        });
      }
    } else {
      //this.authService.emmitLoginStatus(false);
      this.authService.emmitSignalLogout();
    }
    this.getTestConnectionUrls();
  }

  public window;
  public title = 'app works!';
  public loadingPage: LoadInfoDTO = new LoadInfoDTO();

  public routerOutletVisible = true;

  private lastCompletedNavigationWasHome = false;

  public get basicDataLoaded() {
    //Poner acá todos los otros indicadores de cosas cargadas previas a la página
    //Usando && lógico
    return this.translationLoaded && this.optionsLoaded;
  }

  public optionsLoaded = false;

  private translationLoaded = false;

  public static URL_LOGIN = '/auth/login';

  public defaultRedirectUrl = '/home';

  @ViewChild('modalWelcome') modalWelcome: any;

  rememberMe: boolean;

  public isValidSession = true;

  public redirectUrl: string;

  private isHomeRoute(url: string): boolean {
    return url.split(/[?#]/)[0] === '/home';
  }

  private recreateRouterOutlet(): void {
    this.routerOutletVisible = false;
    setTimeout(() => {
      this.routerOutletVisible = true;
    }, 0);
  }

  testConnectionUrlsFromJson: string[] = [];

  private setAlwaysAllowedUrls() {
    let optionAllowed: OptionElementDTO = new OptionElementDTO();
    optionAllowed.url = '/auth/login';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/access-forbidden/*';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/error404';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/error500';
    this.authService.optsAlwaysAllowed.push(optionAllowed);
  }

  public urlNow(url: string) {
    if (url.includes('auth/login')) {
      return true;
    }
    return false;
  }

  // Esto captura la url desde la variable location.href y la convierte a una ruta valida
  // para redirigir a usuario en el caso de que haya solicitado acceder a una ruta tener sesión válida
  private splitUrlRequestedToRedirect(url: string) {
    const urlHttp = url.includes('http:');
    const urlHttps = url.includes('https:');
    if (urlHttp) {
      const strLength = url.length;
      url = url.substr(8, strLength);
      const idxFirstSlash = url.indexOf('/');
      url = url.substring(idxFirstSlash);
      if (url.includes('/#')) {
        url = url.substr(2);
      }
    } else if (urlHttps) {
      const strLength = url.length;
      url = url.substr(9, strLength);
      const idxFirstSlash = url.indexOf('/');
      url = url.substring(idxFirstSlash);
      if (url.includes('/#')) {
        url = url.substr(2);
      }
    } else {
      url = '/home';
    }
    if (url === '/') {
      url = '/home';
    }
    return url;
  }

  private deleteQueryStringToUrl(str: string): string {
    const queryStringIdx: number = str.indexOf('?');
    if (queryStringIdx != -1) {
      const queryString = str.substr(queryStringIdx);
      str = str.replace(queryString, '');
    }
    return str;
  }

  private generateQueryParams(str: string) {
    const queryStringIdx: number = str.indexOf('?');
    const result = {};
    if (queryStringIdx != -1) {
      const urlArr = str.split('?');
      const queryStringsArr = urlArr[1].split('&');
      for (let i = 0; i < queryStringsArr.length; i++) {
        const qsArr = queryStringsArr[i].split('=');
        if (qsArr.length === 2) {
          result[qsArr[0]] = decodeURIComponent(qsArr[1]);
        }
      }
    }
    return result;
  }

  private getCountryFromQueryString(url: string): string {
    const idxOfQueryString = url.indexOf('?');
    const idxOtherQueryString = url.indexOf('&');
    let queryStrings = url.substring(idxOfQueryString);
    let countryFromQueryString = '';
    if (idxOtherQueryString != -1) {
      queryStrings = queryStrings.substring(idxOtherQueryString);
      const idxValue = queryStrings.indexOf('=');
      countryFromQueryString = queryStrings.substring(idxValue);
    } else {
      const idxValue = queryStrings.indexOf('=');
      countryFromQueryString = queryStrings.substring(idxValue + 1);
    }
    return countryFromQueryString;
  }

  private getTestConnectionUrls() {
    this.http
      .get<string[]>(AppComponent.AVLA_TEST_CONNECTION_URLS)
      .pipe(
        catchError(() =>
          Observable.of([AppComponent.DEFAUL_AVLA_TEST_CONNECTION_URL])
        )
      )
      .subscribe(urls => {
        this.testConnectionUrlsFromJson = [...urls];
      });
  }
}
